import {ExecutionResult} from 'graphql'
import * as React from 'react'
import {
  findIntakeWithIdQuery, findIntakeWithIdQueryVariables,
  UpdateOccupationMutation, UpdateOccupationMutationVariables,
} from '../../schema/schemaTypes'
import {apolloClient} from '../../utils/apolloClient'
import {ApolloError} from 'apollo-client'
import {IFormValues, HcpWelcomeFormView} from './HCP_WelcomeFormView'
import {FIND_INTAKE_QUERY_WITH_USERID} from '../../queries/FIND_INTAKE_QUERY_WITH_USERID'
import {UPDATE_OCCUPATION_MUTATION} from '../../mutations/UPDATE_OCCUPATION_MUTATION'
import {IPatientIdStore} from '../../stores/PatientIdStore'
import {FIND_INTAKE_WITH_ID_QUERY} from '../../queries/FIND_INTAKE_WITH_ID_QUERY'

interface IInputProps {
  patientIdStore?: IPatientIdStore
}

interface IChildState {
  is: null | 'filling' | 'ready' | 'error'
  error: null | ApolloError
}

export class HcpWelcomeFormContainer extends React.Component<IInputProps, IChildState> {
  public state: IChildState = {is: 'filling', error: null}

  public render() {
    return <HcpWelcomeFormView
      doSubmitForm={this.doSubmitForm}
      is={this.state.is}
      error={this.state.error}
    />
  }

  private doSubmitForm = async ({occupation, userId}: IFormValues) => {
    this.setState({is: 'ready'})

    this.updateOccupation(occupation, userId)

  }

  private updateOccupation = async (occupation: string, patientId: number) => {
    try {
      const {data}: ExecutionResult<UpdateOccupationMutation> =
        await apolloClient.mutate<UpdateOccupationMutation, UpdateOccupationMutationVariables>({
          mutation: UPDATE_OCCUPATION_MUTATION, variables: {occupation, patientId},
        }) as any
      if (!data || !data.UpdateOccupation) {
        return this.setState({is: 'error'})
      } else {
        await this.getIntakewithId(patientId)
      }

      if(occupation === 'anesthesiologist') {
        location.assign('/HCP1-patientInfo')
      } else {
        location.assign('/HCP3-patientInfo')
      }
    } catch (err) {
      this.setState({is: 'error', error: err})
    }
  }

  private getIntakewithId = async (patientId: number) => {
    try {
      const {data}: ExecutionResult<findIntakeWithIdQuery> =
        await apolloClient.query<findIntakeWithIdQuery, findIntakeWithIdQueryVariables>({
          query: FIND_INTAKE_WITH_ID_QUERY, variables: {id: patientId},
        }) as any
      if (!data || !data.findIntakeWithId) {
        return this.setState({is: 'error'})
      }
      localStorage.setItem('patientID', `${patientId}`)
      localStorage.setItem('patientIntake', JSON.stringify(data.findIntakeWithId))
    } catch (err) {
      this.setState({is: 'error', error: err})
    }
  }
}



// WEBPACK FOOTER //
// ./src/organisms/HCP_Welcome/HCP_WelcomeFormContainer.tsx